import { Controller } from "@hotwired/stimulus";

const WEEKDAY_LABELS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export default class extends Controller {
  static targets = ["label", "grid"];
  static values = { date: String };

  connect() {
    const today = this.dateValue
      ? new Date(`${this.dateValue}T00:00:00`)
      : new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();

    const firstOfMonth = new Date(year, month, 1);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const leadingBlanks = firstOfMonth.getDay();

    this.labelTarget.textContent = firstOfMonth.toLocaleDateString(undefined, {
      month: "long",
    });

    this.gridTarget.innerHTML = "";

    WEEKDAY_LABELS.forEach((label) => {
      const cell = document.createElement("div");
      cell.className =
        "text-[10px] font-medium text-base-content/40 text-center py-0.5";
      cell.textContent = label;
      this.gridTarget.appendChild(cell);
    });

    for (let i = 0; i < leadingBlanks; i++) {
      this.gridTarget.appendChild(document.createElement("div"));
    }

    for (let date = 1; date <= daysInMonth; date++) {
      const cell = document.createElement("div");
      cell.className = `size-6 flex items-center justify-center rounded-full text-xs ${date === day ? "bg-primary text-primary-content font-semibold" : "text-base-content"}`;
      cell.textContent = date;
      this.gridTarget.appendChild(cell);
    }
  }
}
